var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const mockDate = "2020-03-20";
const accountSummaryV2QueryMock = () => ({
  accountInfo: {
    accountLast4: "4234",
    multiplePresentationInstruments: false
  },
  profile: {
    "cipher.firstName": "Jack",
    addressOnHold: false
  },
  product: {
    portfolio: "Home",
    type: "INSTALLMENT_LOAN",
    lineOfBusiness: "RETAIL_CARD",
    displayName: "VISA_SIGNATURE_BLUE",
    clientId: "clientId",
    portfolioLogo: "https://www.mysynchrony.com/sites/mysyf/img/care-credit-logo-template.png"
  },
  card: {
    cardType: "DUALCARD",
    partnerId: "PARTNER_ID",
    cardArtURL: "https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img047178.png"
  },
  billing: {
    statementEnrollment: "ELECTRONIC",
    autopayEnrollment: true,
    lastPaymentAmount: "27.99",
    lastPaymentDate: mockDate,
    statementBalance: "350.99",
    nextPaymentDate: "2020-04-20",
    pastDue: true,
    pastDueAmount: "137.95",
    daysDelinquent: "15",
    customerAssistancePlan: true,
    settlementEnrolled: true,
    fixedPaymentAmount: "15.99",
    interestPaid: "34.87",
    totalMinimumPaymentDue: "243.31",
    outstandingFeesAndCharges: "345.39"
  },
  credit: {
    annualPercentageRate: "19.99",
    annualPercentageRateType: "FIXED",
    availableCredit: "99.99",
    creditLimit: "8000.00",
    currentBalance: "248.44",
    temporaryCreditLimit: "1200.00"
  },
  installment: {
    principalAmount: "1000.99",
    monthlyAmountDue: "50.05",
    nextPaymentDueAmount: "0.00",
    totalAmountPaid: "1000.99",
    startDate: mockDate,
    endDate: "2021-03-20",
    interestRate: "27.99",
    loanTerm: "12",
    payoffValidThrough: mockDate,
    purchaseAmount: "12.99",
    principalRemaining: "68.82",
    termRemaining: 1
  },
  rewards: {
    currency: "DOLLARS",
    rewardsBalance: "300.99"
  },
  servicing: {
    allowable: true,
    reason: "account.servicing.generic_restriction"
  },
  conditions: ["OPEN"],
  enrollments: []
});
const accountSummaryPayInFourMock = () => {
  const data = accountSummaryV2QueryMock();
  const { installment, credit } = data;
  return __spreadProps(__spreadValues({}, data), {
    installment: __spreadProps(__spreadValues({}, installment), {
      principalAmount: "200",
      monthlyAmountDue: "50",
      nextPaymentDueAmount: "10.50",
      totalAmountPaid: "50",
      purchaseAmount: "200",
      principalRemaining: "150",
      termRemaining: 3
    }),
    credit: __spreadProps(__spreadValues({}, credit), {
      currentBalance: "150"
    })
  });
};
const accountSummaryWaivedInterestMock = () => {
  const data = accountSummaryV2QueryMock();
  const { product, billing } = data;
  return __spreadProps(__spreadValues({}, data), {
    product: __spreadProps(__spreadValues({}, product), {
      type: "INSTALLMENT_LOAN_MONTHLY",
      lineOfBusiness: "SETPAY",
      displayName: "Monthly Product Type Waived interest"
    }),
    billing: __spreadProps(__spreadValues({}, billing), {
      waivedInterest: {
        promoEndDate: mockDate,
        payOffBalance: "948.33",
        paymentAmount: "100.00"
      }
    }),
    enrollments: ["WAIVED_INTEREST"]
  });
};
export { accountSummaryPayInFourMock, accountSummaryWaivedInterestMock, accountSummaryV2QueryMock as default };
//# sourceMappingURL=accountSummaryV2QueryMock.js.map
